/* global $:false BroadcastChannel:false */

import 'jquery-ui/sortable.js'

export default class ContentBlockSlugs {
  static init () {
    this.el = $('#manage-content-blocks')
    if (!(this.el.length > 0)) { return }
    $('#content-block-slugs').sortable()

    this.contentBlocks = this.el.find('#content-block-slugs')
    this.updateUrl = this.el.data('update-url')

    this.contentBlocks.on('sortupdate', (e, ui) => {
      this.updateBlocks()
    })
  }

  static updateBlocks () {
    $.ajax(
      this.updateUrl, {
        type: 'PUT',
        dataType: 'json',
        data: { content_block_slugs: $('#content-block-slugs').sortable('toArray', { attribute: 'data-slug' }) },
        success: data => {
          new BroadcastChannel('employee_preview').postMessage('reload')
        }
      }
    )
  }
}
